import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { UserRole } from 'types';

export const getUsers = (state: RootState) => state.users.users;
export const getUsersLoading = (state: RootState) => state.users.isLoading;

export const getDoctors = createSelector([getUsers], (users) => {
  return users.filter((user) => user.role === UserRole.DOCTOR);
});
export const getClinics = createSelector([getUsers], (users) => {
  return users.filter((user) => user.role === UserRole.CLINIC);
});

export const selectOnlineUsers = (state: RootState) => state.users.onlineUsersIds;
